export default "__VITE_ASSET__CmhiKf69__"